import { render } from "./BaseTabPanel.vue?vue&type=template&id=54944930&scoped=true"
import script from "./BaseTabPanel.vue?vue&type=script&lang=js"
export * from "./BaseTabPanel.vue?vue&type=script&lang=js"

import "./BaseTabPanel.vue?vue&type=style&index=0&id=54944930&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54944930"]])

export default __exports__